import React from "react";
import { dataMap } from "@/constants/distribution";
import { 
  BarChartOutlined, 
  TableOutlined, 
  AppstoreOutlined,
} from '@ant-design/icons';
import "./distribution.less";

const DistributionShowBtn = (props: any) => {
  const { 
    currentMode, 
    setCurrentMode, 
    showMode, 
    setShowMode, 
    setCurrentData, 
    type = "img" 
  } = props;

  const handleModeChange = (key: string) => {
    setCurrentMode(key);
    if (setCurrentData) {
      setCurrentData(null);
    }
  };

  const handleShowModeChange = (mode: "chart" | "table") => {
    setShowMode(mode);
  };

  return (
    <div className="show-btns-container">
      {/* 参数模式切换按钮组 - 兼容原生 button 或 antd Button */}
      <div className="mode-btn-group">
        {Object.keys(dataMap).map((key: string, index: number) => {
          const isActive = currentMode === key;
          return (
            <div 
              key={key} 
              className={`mode-btn-item ${isActive ? "active" : ""}`}
              style={{
                borderTopRightRadius: index === Object.keys(dataMap).length - 1 ? "5px" : "0",
                borderBottomRightRadius: index === Object.keys(dataMap).length - 1 ? "5px" : "0",
                borderTopLeftRadius: index === 0 ? "3px" : "0",
                borderBottomLeftRadius: index === 0 ? "3px" : "0",
              }}
            >
              {/* 方案A: 原生 button（保持原有样式） */}
              <button
                className={`mode-btn ${isActive ? "active" : ""}`}
                onClick={() => handleModeChange(key)}
              >
                <span className={`mode-btn-text ${isActive ? "active" : ""}`}>
                  {dataMap[key]?.title || key}
                </span>
              </button>
            </div>
          );
        })}
      </div>

      {/* 图表/表格切换按钮组 */}
      {/* <div className="view-type-btn-group">
        <button
          className={`view-type-btn chart-btn ${showMode === "chart" ? "active" : ""}`}
          onClick={() => handleShowModeChange("chart")}
        >
          <BarChartOutlined 
            style={{
              fontSize: 16,
              color: showMode === "chart" ? "#fff" : "#bebebe"
            }}
          />
        </button>
        <button
          className={`view-type-btn table-btn ${showMode === "table" ? "active" : ""}`}
          onClick={() => handleShowModeChange("table")}
        >
          {type === "img" ? (
            <AppstoreOutlined // 或 GridOutlined
              style={{
                fontSize: 16,
                color: showMode === "table" ? "#fff" : "#bebebe"
              }}
            />
          ) : (
            <TableOutlined
              style={{
                fontSize: 16,
                color: showMode === "table" ? "#fff" : "#bebebe"
              }}
            />
          )}
        </button>
      </div> */}
    </div>
  );
};

export default DistributionShowBtn;